<template>
    <div>
        <b-button class="m-1" v-b-modal.createPreguntasModal variant="primary"> 
            Crear pregunta <b-icon icon="question-square" font-scale="1"></b-icon>
        </b-button>

        <!-- Modal tipo de preguntas -->
        <b-modal id="createPreguntasModal" title="Crear preguntas" size="md" centered scrollable
            header-bg-variant="dark" v-model="modalShow" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <!-- cuerpo del modal -->
             <TypeDenounceForm></TypeDenounceForm>

        </b-modal>
    </div>
</template>
<script>

import TypeDenounceForm from './SettingTypeDenounce/Type-denounce-form.vue'

export default {
    name: 'SettingTypeDenounce',

    data() {
        return {
            modalShow: false
        }
    },

    components:{
        TypeDenounceForm
    },

    methods: {
        openModalTypeUser() {
            this.modalShow = true;
        },

        closeModalTypeUser() {
            this.modalShow = false;
        }
    }

}
</script>
<style></style>